/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Request_Invalid_BodyInputs */

const en_us2_request_invalid_body = /** @type {(inputs: Request_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something in that request was not valid. Update the app and try again.`)
};

const pt_br2_request_invalid_body = /** @type {(inputs: Request_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo nesse pedido não era válido. Atualize o app e tente de novo.`)
};

const es_419_request_invalid_body = /** @type {(inputs: Request_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo en esa solicitud no era válido. Actualiza la app e inténtalo de nuevo.`)
};

const pt_pt2_request_invalid_body = /** @type {(inputs: Request_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo neste pedido não era válido. Atualiza a app e tenta de novo.`)
};

const fr_fr2_request_invalid_body = /** @type {(inputs: Request_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelque chose dans cette requête n'était pas valide. Mets l'app à jour et réessaie.`)
};

const de_de2_request_invalid_body = /** @type {(inputs: Request_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas an dieser Anfrage war ungültig. Aktualisiere die App und versuch es erneut.`)
};

const it_it2_request_invalid_body = /** @type {(inputs: Request_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualcosa in questa richiesta non era valido. Aggiorna l'app e riprova.`)
};

/**
* | output |
* | --- |
* | "Something in that request was not valid. Update the app and try again." |
*
* @param {Request_Invalid_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const request_invalid_body = /** @type {((inputs?: Request_Invalid_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Request_Invalid_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_request_invalid_body(inputs)
	if (locale === "es-419") return es_419_request_invalid_body(inputs)
	if (locale === "pt-PT") return pt_pt2_request_invalid_body(inputs)
	if (locale === "fr-FR") return fr_fr2_request_invalid_body(inputs)
	if (locale === "de-DE") return de_de2_request_invalid_body(inputs)
	if (locale === "it-IT") return it_it2_request_invalid_body(inputs)
	return en_us2_request_invalid_body(inputs)
});
export { request_invalid_body as "request.invalid_body" }